class TC_ChannelChapters {
    static playLastListenedChapter (channels, channelID) {
        let storyID = channels.remoteData.channelsToStoryMap[channelID];
        let timetableCachedData = channels.timetableCache.getTimetable(storyID);
        let lastListenedChapter = channels.remoteData.lastListenedChapters[channelID];

        if (!lastListenedChapter) {
            lastListenedChapter = 1;
        }

        if (timetableCachedData !== false) {
            let startTime = timetableCachedData.tracks[lastListenedChapter - 1].start;
            channels.playerInstance.loadChannel(channelID, true, false, startTime);
        } else {
            let url = TC_ChannelChapters.getStoryTimetableUrl(channels.remoteData, channelID);
            let timetableUrl = url + '?username=' + channels.user.login + '&token=' + channels.user.token;

            $.get({
                url: timetableUrl,
                dataType: 'json',
                success: (data, status) => {
                    if (!(status === 'success' && data)) {
                        return;
                    }
        
                    channels.timetableCache.saveTimetable(storyID, data);
                    let startTime = data.tracks[lastListenedChapter - 1].start;
                    channels.playerInstance.loadChannel(channelID, true, false, startTime);
                }
            });
        }
    }
    
    static isStoryChannel (remoteData, channelID, userIsVip) {
        return userIsVip && remoteData.channelsWithStories.indexOf(channelID) > -1;
    }

    static getStoryTimetableUrl (remoteData, channelID) {
        let storyID = remoteData.channelsToStoryMap[channelID];
        return remoteData.storiesTimetables[storyID];
    }

    static getStoryTimetable (channels, url, channelID, where = 'channels') {
        let storyID = channels.remoteData.channelsToStoryMap[channelID];
        let timetableUrl = url + '?username=' + channels.user.login + '&token=' + channels.user.token;
        let timetableCachedData = channels.timetableCache.getTimetable(storyID);

        if (timetableCachedData !== false) {
            if (where === 'channels') {
                TC_ChannelChapters.displayTimetable(channels, timetableCachedData, channelID);
            } else if (where === 'player') {
                TC_ChannelChapters.displayTimetableInPlayer(channels, timetableCachedData, channelID);
            }
            
            return;
        }

        TC_ChannelChapters.downloadStoryTimetable(channels, timetableUrl, storyID, channelID);
    }

    static downloadStoryTimetable (channels, url, storyID, channelID, where = 'channels') {
        $.get({
            url: url,
            dataType: 'json',
            success: (data, status) => {
                if (!(status === 'success' && data)) {
                    return;
                }
    
                channels.timetableCache.saveTimetable(storyID, data);
                let currentlyExpandedChannel = parseInt($('.calmchristian-channels-expanded').attr('data-expanded-channel'), 10);

                if (channelID === currentlyExpandedChannel) {
                    if (where === 'channels') {
                        TC_ChannelChapters.displayTimetable(channels, data, channelID);
                    } else if (where === 'player') {
                        TC_ChannelChapters.displayTimetableInPlayer(channels, data, channelID);
                    }
                }
            }
        });
    }

    static generateTimetable (data, channelID) {
        let translatedTitle = DOMPurify.sanitize(window.CSITE_LANGS.channels.chapters.title);
        let chaptersContent = `
            <div class="channel-chapters">
                <div class="channel-chapters-ui">
                    <strong class="channel-chapters-title">%CHAPTERS_TITLE%</strong>
                </div>
                <div class="channel-chapters-current-item"></div>
                <div class="channel-chapters-list-wrapper is-closed">
                    <ol class="channel-chapters-list">%CHAPTERS_LIST%</ol>
                </div>
            </div>`;
        let chapterItemTemplate = `
            <li class="channel-chapters-item" data-chapter-number="%CHAPTER_NUMBER%">
                <a href="#" class="channel-chapters-item-link" data-start="%START_TIME%" data-channel-id="%CHANNEL_ID%" title="%TITLE_ATTR%">%TITLE%</a>
            </li>`;
        let chaptersList = '';

        for (let i = 0; i < data.tracks.length; i++) {
            let trackID = data.tracks[i].id;
            let trackTitle = data.metadata[trackID].title;
            let trackStartTime = data.tracks[i].start;

            trackTitle = trackTitle.split(':');

            if (trackTitle.length > 1) {
                trackTitle = '<span class="channel-chapters-item-link-chapter">' + trackTitle[0] + ': </span>' +trackTitle.slice(1).join(':');
            } else {
                trackTitle = trackTitle.join(':');
            }

            chaptersList += chapterItemTemplate.replace('%CHANNEL_ID%', channelID)
                                               .replace('%CHAPTER_NUMBER%', i + 1)
                                               .replace('%START_TIME%', trackStartTime)
                                               .replace('%TITLE%', trackTitle)
                                               .replace('%TITLE_ATTR%', data.metadata[trackID].title);
        }

        return chaptersContent.replace('%CHAPTERS_TITLE%', translatedTitle).replace('%CHAPTERS_LIST%', DOMPurify.sanitize(chaptersList));
    }

    static displayTimetable (channels, data, channelID) {
        let expandedContent = $('.calmchristian-channels-expanded');
        expandedContent.removeClass('is-timetable-loading');
        let timetableHTML = TC_ChannelChapters.generateTimetable(data, channelID);
        expandedContent.find('.calmchristian-channels-slider-expanded-content-chapters').html(timetableHTML);
        
        setTimeout(() => {
            let wrapper = expandedContent.find('.calmchristian-channels-slider-expanded-content-chapters');
            
            if (channels.remoteData.lastListenedChapters && channels.remoteData.lastListenedChapters[channelID]) {
                let chapterToMarkAsCurrent = parseInt(channels.remoteData.lastListenedChapters[channelID], 10);
                let itemToMarkAsCurrent = wrapper.find('.channel-chapters-item[data-chapter-number="' + chapterToMarkAsCurrent + '"]');
               
                if (itemToMarkAsCurrent.length) {
                    itemToMarkAsCurrent.eq(0).addClass('is-current');
                    expandedContent.find('.channel-chapters-current-item').text(itemToMarkAsCurrent.eq(0).text());
                }   
            } else {
                let itemToMarkAsCurrent = wrapper.find('.channel-chapters-item[data-chapter-number="1"]');

                if (itemToMarkAsCurrent.length) {
                    itemToMarkAsCurrent.eq(0).addClass('is-current');
                    expandedContent.find('.channel-chapters-current-item').text(itemToMarkAsCurrent.eq(0).text());
                }
            }
        }, 0);
    }

    static displayTimetableInPlayer (channels, data, channelID) {
        if (parseInt($('.cr-player-album-info-chapters').attr('data-channel-id'), 10) === channelID) {
            return;
        }

        let timetableHTML = TC_ChannelChapters.generateTimetable(data, channelID);
        $('.cr-player-album-info-chapters').html(timetableHTML);
        $('.cr-player-album-info-chapters').attr('data-channel-id', channelID);
        $('.cr-player-album-info-chapters').removeClass('is-hidden');

        setTimeout(() => {
            let wrapper = $('.cr-player-album-info-chapters');
            
            if (channels.remoteData.lastListenedChapters && channels.remoteData.lastListenedChapters[channelID]) {
                let chapterToMarkAsCurrent = parseInt(channels.remoteData.lastListenedChapters[channelID], 10);
                let itemToMarkAsCurrent = wrapper.find('.channel-chapters-item[data-chapter-number="' + chapterToMarkAsCurrent + '"]');

                if (itemToMarkAsCurrent.length) {
                    itemToMarkAsCurrent.eq(0).addClass('is-current');
                    wrapper.find('.channel-chapters-current-item').text(itemToMarkAsCurrent.eq(0).text());
                }   
            } else {
                let chapterToMarkAsCurrent = 1;
                let itemToMarkAsCurrent = wrapper.find('.channel-chapters-item[data-chapter-number="' + chapterToMarkAsCurrent + '"]');

                if (itemToMarkAsCurrent.length) {
                    itemToMarkAsCurrent.eq(0).addClass('is-current');
                    wrapper.find('.channel-chapters-current-item').text(itemToMarkAsCurrent.eq(0).text());
                }
            }
        }, 0);
    }
}